import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {LoginComponent} from "./pages/login/login.component";
import {MainComponent} from "./pages/main/main.component";
import {AuthenticatedGuard} from "./guards/authenticated.guard";
import {ForgotPasswordComponent} from "./pages/forgot-password/forgot-password.component";
import {ResetPasswordComponent} from "./pages/reset-password/reset-password.component";
import {KitsComponent} from "./pages/kits/kits.component";
import {OrdersComponent} from "./pages/orders/orders.component";
import {InstitutionsComponent} from "./pages/institutions/institutions.component";
import {InstitutionComponent} from "./pages/institution/institution.component";
import {InstOrdersComponent} from "./pages/institution/inst-orders/inst-orders.component";
import {InstOrderComponent} from "./pages/institution/inst-order/inst-order.component";
import {PromosComponent} from "./pages/promos/promos.component";
import {PromoComponent} from "./pages/promos/promo/promo.component";
import {BackendUsersComponent} from "./pages/backend-users/backend-users.component";
import {SiteUsersComponent} from "./pages/site-users/site-users.component";
import {SiteUserComponent} from "./pages/site-user/site-user.component";
import {BackendUserComponent} from "./pages/backend-user/backend-user.component";

const routes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'forgot-password', component: ForgotPasswordComponent },
    { path: 'reset-password/:token', component: ResetPasswordComponent },
    { path: '', component: MainComponent, canActivate: [AuthenticatedGuard] },
    { path: 'backend-users', component: BackendUsersComponent, canActivate: [AuthenticatedGuard] },
    { path: 'backend-user', component: BackendUserComponent, canActivate: [AuthenticatedGuard] },
    { path: 'site-users', component: SiteUsersComponent, canActivate: [AuthenticatedGuard] },
    { path: 'site-user', component: SiteUserComponent, canActivate: [AuthenticatedGuard] },
    { path: 'kits', component: KitsComponent, canActivate: [AuthenticatedGuard] },
    { path: 'orders', component: OrdersComponent, canActivate: [AuthenticatedGuard] },
    { path: 'promos', component: PromosComponent, canActivate: [AuthenticatedGuard] },
    { path: 'promo', component: PromoComponent, canActivate: [AuthenticatedGuard] },
    { path: 'institutions', component: InstitutionsComponent, canActivate: [AuthenticatedGuard] },
    { path: 'institution', component: InstitutionComponent, canActivate: [AuthenticatedGuard] },
    { path: 'institution/order', component: InstOrderComponent, canActivate: [AuthenticatedGuard] },
    { path: 'institution/orders', component: InstOrdersComponent, canActivate: [AuthenticatedGuard] },
    { path: '**', redirectTo: '' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
